var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"ue-qr",attrs:{"title":"打开微信“扫一扫”，打开网页后点击屏幕右上角分享按钮","visible":_vm.visible,"width":"30%"},on:{"close":() => {_vm.visible=false; this.closeEvent()}}},[_c('canvas',{attrs:{"id":"qr"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }